import React from 'react'
import { Link } from 'react-router'
import ACCESS from 'utils/Access'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import LeadContactPropertyMapping from './LeadContactPropertyMapping'
import AccountPropertyMapping from './AccountPropertyMapping'

import './style.styl'

const HELP_DOC_URL = 'https://help.drift.com/integrations/mapping-salesforce-attributes'


export const MappingType = {
  LEAD: 'lead',
  CONTACT: 'contact',
  CASE: 'case',
  ACCOUNT: 'account'
}


const SalesforceMapping = (
  {
    hasCaseCutover,
    selectedTab,
    onTabClick,
  }
) => {


  return (
    <div className="common-integration-page-layout">
      <IntegrationBreadcrumb
        backLinkText="Salesforce Integration"
        backLinkUrl="/settings/setup/salesforce"
      />
      <header>
        <h2 className="integration-header">Mapped Salesforce Attributes</h2>
        <p>You can map exisiting Drift Attributes or static values to your Leads, Contacts, {hasCaseCutover ? 'Cases, ' : ''}and Accounts in Salesforce.
          <a href={HELP_DOC_URL}> Learn More</a>
        </p>
        <Link
          className="event-log-link"
          to="/settings/salesforce/event-log"
        >
          View Salesforce Event Log
        </Link>
      </header>

      <div className="salesforce-property-mapping-tabs">
        <span
          className={selectedTab === MappingType.LEAD && 'selected'}
          onClick={() => onTabClick(MappingType.LEAD)}
        >
          Lead Properties
        </span>
        <span
          className={selectedTab === MappingType.CONTACT && 'selected'}
          onClick={() => onTabClick(MappingType.CONTACT)}
        >
          Contact Properties
        </span>
        {hasCaseCutover &&
          <span
            className={selectedTab === MappingType.CASE && 'selected'}
            onClick={() => onTabClick(MappingType.CASE)}
          >
            Case Properties
          </span>
        }
        {ACCESS.hasGates('SALESFORCE_ACCOUNT_MAPPING') &&
          <span
            className={selectedTab === MappingType.ACCOUNT && 'selected'}
            onClick={() => onTabClick(MappingType.ACCOUNT)}
          >
            Account Properties
          </span>
        }
      </div>
      {selectedTab === MappingType.ACCOUNT
        ? <AccountPropertyMapping />
        : <LeadContactPropertyMapping key={selectedTab} type={selectedTab} />
      }

    </div>
  )
}

export default SalesforceMapping



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceMapping/component.js